import type { ContainerStatus, ContainerType } from '../containers'
import type { IMinerIdentifier } from '../miners'

export enum ShipmentType {
  Inbound = 'Inbound',
  Outbound = 'Outbound',
}

export enum ShipmentStatus {
  Created = 'Created',
  InTransit = 'In Transit',
  ReadyToShip = 'Ready to Ship',
  Delivered = 'Delivered',
  Cancelled = 'Cancelled',
}

export interface IWorkOrderShipment {
  id: number
  carrier: string | null
  tracking_number: string | null
  status: string
}

export interface IDamageInstance {
  id: string
  description: string
  file_url: string
  containerNumber?: string
  picture?: File
}

export interface IContainer {
  id: number
  status: ContainerStatus
  type: string
  amount?: number
  work_order_number: string
  customer: {
    id: number
    name: string
  }
  expected_miners: number | null
  number: string
  shipment: IShipmentTrackingInformation | null
  damages: IDamageInstance[]
  miners: IMinerIdentifier[]
  kind?: ShipmentType
  length: number | null
  width: number | null
  height: number | null
  weight: number | null
}

export interface IContainersSetup {
  type: string
  amount: number | null
}

export interface IContainerOption {
  key: string
  value: string
}

interface IShipmentTrackingInformation {
  id: number
  status: string
  carrier: string | null
  tracking_number: string | null
  bol_number: string | null
  waybill_number: string | null
}

export interface IDashboardShipment {
  id: number
  work_order_number: string
  type: string
  customer: string
  status: string
  tracking_information: IShipmentTrackingInformation
  expected_containers: number | null
  customer_drop_off: boolean
  customer_pick_up: boolean
  picked_up_date: string | null
  delivered_date: string | null
}

interface IShipmentDetails {
  carrier_type: string | null
  carrier_code: string | null
  carrier_status: string | null
  notes: string[] | null
}

export interface IShipmentReceipt {
  id: number
  file_url: string
  name: string
}

export interface IShipment {
  id: number
  details: IShipmentDetails
  status: ShipmentStatus
  work_order: {
    number: string
    customer: string
  }
  tenant_id: string
  type: ShipmentType
  carrier: string
  expected_containers: number
  expected_miners: number
  expected_container_types: ContainerType[]
  tracking_number: string | null
  bol_number: string | null
  waybill_number: string | null
  picked_up_date: string | null
  delivered_date: string | null
  created_at: string // Date
  updated_at: string // Date
  receipts: IShipmentReceipt[]

  // Inbound-only
  customer_drop_off: boolean

  // Outbound-only
  customer_pick_up: boolean
}

export interface IShipmentContainer {
  id: number
  number: string
  type: ContainerType
  work_order_number: string
  expected_miners: number
  status: ContainerStatus
  damages: IDamageInstance[]
}
